export default "__VITE_ASSET__CxbMhXJI__"